<template>
  <div id="account-linking" class="section">
    <h1>
      <span class="section-title">Account Linking</span>
      <span class="section-description">アカウントを1つにまとめましょう</span>
    </h1>
    <p>同じメールアドレスで複数のアカウントを検知しました。<br>1つのアカウントに統合してログインを簡略化しましょう💁</p>
    <hr>
    <p class="has-text-weight-bold">現在ログインしているユーザーに下記ユーザーが統合されます</p>
    <p>アップロードしたファイル・グループなどは統合先のアカウントで管理できます</p>
    <div class="margin-top-30px margin-bottom-30px">
      <p class="has-text-weight-bold" style="font-size:18px">統合先</p>
      <b-tag type="is-info">ユーザーID {{ $store.state.user.sub }}</b-tag>
      <b-tag type="is-info">メールアドレス {{ $store.state.user.email }}</b-tag>
      <b-tag type="is-info">ファイル数 {{ $store.state.loginInit['usage']['count'] }}</b-tag>

      <div style="margin: 48px 0 30px 0">
        <font-awesome-icon :icon="['fas', 'up-long']" size="2x" />
      </div>

      <b-table :data="$store.state.loginInit.users">
        <b-table-column label="ユーザーID" centered v-slot="props">
          {{ props.row.user_id }}
        </b-table-column>
        <b-table-column label="メールアドレス" centered v-slot="props">
          {{ props.row.email }}
        </b-table-column>
        <b-table-column label="ファイル数" centered numeric v-slot="props">
          {{ props.row['usage']['count'] }}
        </b-table-column>
      </b-table>
    </div>
    <b-button class="has-text-weight-bold is-primary" icon-left="code-merge" @click="link">統合する</b-button>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useHead } from "@unhead/vue";

export default {
  name: "AccountLinking",
  created() {
    useHead({
      title: `アカウント統合 | ${appConfig[this.$i18n.locale].title}`,
      meta: [
        { name: 'description', content: appConfig[this.$i18n.locale].description.top },
        { name: 'robots', content: 'noindex,nofollow' }
      ],
    })
  },
  methods: {
    link: function () {
      this.OpenLoading()

      this.$axios.post('/user/link', {}, { headers: { 'Authorization': `Bearer ${this.$store.state.token}` } })
        .then(res => {
          this.CloseLoading()
          this.$router.push(`/${this.$i18n.locale}/dashboard`).catch(() => { })
        })
        .catch(err => {
          this.CloseLoading()
          this.toastError(err)
        })
    }
  }
}
</script>

<style scoped></style>
